const pluginName = {
    glacier_pib: '/products/glacier-plug-in-battery',
    glacier_dwal: '/products/glacier-detachable-wheels-and-lever',
    glacier_bag: '/products/glacier-bag',
    blade_lsk: '/products/blade-lawn-sweeper-kit',
    blade_seb: '/products/blade-smart-extra-battery',
    wave2_aob: '/products/wave-2-add-on-battery',
    wave2_ed: '/products/wave-2-exhaust-ducts',
    wave2_bag: '/products/wave-2-bag',
};

export const accessoriesKey = {
    'wave2-add-on-battery': 'wave2-add-on-battery',
    'wave2-exhaust-ducts': 'wave2-exhaust-ducts',
    'wave2-bag': 'wave2-bag',
    'glacier-battery': 'glacier-battery',
    'glacier-wheels': 'glacier-wheels',
    'glacier-bag': 'glacier-bag',
    'blade-seb': 'blade-seb',
    'blade-lsk': 'blade-lsk',
};

export const accessoriesLink = {
    [accessoriesKey['glacier-battery']]: {
        us: `https://us.ecoflow.com${pluginName.glacier_pib}`,
        ca: `https://ca.ecoflow.com${pluginName.glacier_pib}`,
        eu: `https://eu.ecoflow.com${pluginName.glacier_pib}`,
        uk: `https://uk.ecoflow.com${pluginName.glacier_pib}`,
        de: `https://de.ecoflow.com${pluginName.glacier_pib}`,
        fr: `https://fr.ecoflow.com${pluginName.glacier_pib}`,
        it: `https://it.ecoflow.com${pluginName.glacier_pib}`,
        es: `https://es.ecoflow.com${pluginName.glacier_pib}`,
        cn: `https://item.m.jd.com/product/10073167029572.html`,
        kr: 'https://kr.ecoflow.com/products/glacier-portable-refrigerator?variant=43040873283753',
        au: `https://au.ecoflow.com${pluginName.glacier_pib}`,
    },
    [accessoriesKey['glacier-wheels']]: {
        us: `https://us.ecoflow.com${pluginName.glacier_dwal}`,
        ca: `https://ca.ecoflow.com${pluginName.glacier_dwal}`,
        eu: `https://eu.ecoflow.com${pluginName.glacier_dwal}`,
        uk: `https://uk.ecoflow.com${pluginName.glacier_dwal}`,
        de: `https://de.ecoflow.com${pluginName.glacier_dwal}`,
        fr: `https://fr.ecoflow.com${pluginName.glacier_dwal}`,
        it: `https://it.ecoflow.com${pluginName.glacier_dwal}`,
        es: `https://es.ecoflow.com${pluginName.glacier_dwal}`,
        cn: `https://item.m.jd.com/product/10073167029573.html`,
    },
    [accessoriesKey['glacier-bag']]: {
        us: `https://us.ecoflow.com${pluginName.glacier_bag}`,
        ca: `https://ca.ecoflow.com${pluginName.glacier_bag}`,
        eu: `https://eu.ecoflow.com${pluginName.glacier_bag}`,
        uk: `https://uk.ecoflow.com${pluginName.glacier_bag}`,
        de: `https://de.ecoflow.com${pluginName.glacier_bag}`,
        fr: `https://fr.ecoflow.com${pluginName.glacier_bag}`,
        it: `https://it.ecoflow.com${pluginName.glacier_bag}`,
        es: `https://es.ecoflow.com${pluginName.glacier_bag}`,
        au: `https://au.ecoflow.com${pluginName.glacier_bag}`,
    },
    [accessoriesKey['blade-lsk']]: {
        us: `https://us.ecoflow.com${pluginName.blade_lsk}`,
        ca: `https://ca.ecoflow.com${pluginName.blade_lsk}`,
        eu: `https://eu.ecoflow.com${pluginName.blade_lsk}`,
        uk: `https://uk.ecoflow.com${pluginName.blade_lsk}`,
        de: `https://de.ecoflow.com${pluginName.blade_lsk}`,
        fr: `https://fr.ecoflow.com${pluginName.blade_lsk}`,
        it: `https://it.ecoflow.com${pluginName.blade_lsk}`,
        es: `https://es.ecoflow.com${pluginName.blade_lsk}`,
    },
    [accessoriesKey['blade-seb']]: {
        us: `https://us.ecoflow.com${pluginName.blade_seb}`,
        ca: `https://ca.ecoflow.com${pluginName.blade_seb}`,
        eu: `https://eu.ecoflow.com${pluginName.blade_seb}`,
        uk: `https://uk.ecoflow.com${pluginName.blade_seb}`,
        de: `https://de.ecoflow.com${pluginName.blade_seb}`,
        fr: `https://fr.ecoflow.com${pluginName.blade_seb}`,
        it: `https://it.ecoflow.com${pluginName.blade_seb}`,
        es: `https://es.ecoflow.com${pluginName.blade_seb}`,
    },
    [accessoriesKey['wave2-add-on-battery']]: {
        us: `https://us.ecoflow.com${pluginName.wave2_aob}`,
        ca: `https://ca.ecoflow.com${pluginName.wave2_aob}`,
        eu: `https://eu.ecoflow.com${pluginName.wave2_aob}`,
        uk: `https://uk.ecoflow.com${pluginName.wave2_aob}`,
        de: `https://de.ecoflow.com${pluginName.wave2_aob}`,
        fr: `https://fr.ecoflow.com${pluginName.wave2_aob}`,
        it: `https://it.ecoflow.com${pluginName.wave2_aob}`,
        es: `https://es.ecoflow.com${pluginName.wave2_aob}`,
        cn: `https://item.jd.com/10073169630427.html`,
        kr: `https://kr.ecoflow.com/products/wave-2-portable-air-conditioner?variant=43040883310761`,
        au: `https://au.ecoflow.com${pluginName.wave2_aob}`,
    },
    [accessoriesKey['wave2-exhaust-ducts']]: {
        us: `https://us.ecoflow.com${pluginName.wave2_ed}`,
        ca: `https://ca.ecoflow.com${pluginName.wave2_ed}`,
        eu: `https://eu.ecoflow.com${pluginName.wave2_ed}`,
        uk: `https://uk.ecoflow.com${pluginName.wave2_ed}`,
        de: `https://de.ecoflow.com${pluginName.wave2_ed}`,
        fr: `https://fr.ecoflow.com${pluginName.wave2_ed}`,
        it: `https://it.ecoflow.com${pluginName.wave2_ed}`,
        es: `https://es.ecoflow.com${pluginName.wave2_ed}`,
        au: `https://au.ecoflow.com${pluginName.wave2_ed}`,
    },
    [accessoriesKey['wave2-bag']]: {
        us: `https://us.ecoflow.com${pluginName.wave2_bag}`,
        ca: `https://ca.ecoflow.com${pluginName.wave2_bag}`,
        eu: `https://eu.ecoflow.com${pluginName.wave2_bag}`,
        uk: `https://uk.ecoflow.com${pluginName.wave2_bag}`,
        de: `https://de.ecoflow.com${pluginName.wave2_bag}`,
        fr: `https://fr.ecoflow.com${pluginName.wave2_bag}`,
        it: `https://it.ecoflow.com${pluginName.wave2_bag}`,
        es: `https://es.ecoflow.com${pluginName.wave2_bag}`,
        au: `https://au.ecoflow.com${pluginName.wave2_bag}`,
    },
};
